module.exports = __webpack_public_path__ + "static/media/206-gallery20.129477ee.jpg";